import { type LinksFunction, type MetaFunction } from 'react-router'
import TilesHomePageContainer from 'pages/HomePage/TilesHomePageContainer'
import useHomePageHeroVideoCldId from 'pages/HomePage/useHomePageHeroVideoCldId'
import MultiProductHomePage from 'pages/MultiProductHomePage/MultiProductHomePage'
import RootHeightAuto from 'styles/root-height-auto'
import { mergeMeta } from 'utils/remixUtils'
import { getOrigin } from 'utils/UrlUtils'
import { DEFAULT_SITE_TITLE } from '../utils/consts'
import { getTitleMetaTags } from 'app/utils/meta'
import useMultiProductHomePageExperiment from 'pages/MultiProductHomePage/useMultiProductHomePageExperiment'

export const meta: MetaFunction = mergeMeta(() => {
  return [...getTitleMetaTags(DEFAULT_SITE_TITLE)]
})
export const links: LinksFunction = () => {
  return [{ rel: 'canonical', href: getOrigin() }]
}

function TilesHomePage() {
  const heroVideoCldId = useHomePageHeroVideoCldId()

  return <TilesHomePageContainer heroVideoCldId={heroVideoCldId} />
}

export default function IndexRoute() {
  const { isEnabled: showMultiProductHomePage } =
    useMultiProductHomePageExperiment()

  return (
    <>
      <RootHeightAuto />
      {showMultiProductHomePage ? <MultiProductHomePage /> : <TilesHomePage />}
    </>
  )
}
